module.exports = __webpack_public_path__ + "static/media/iconmonstr-briefcase-1.c032ae62.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/iconmonstr-briefcase-1.svg
// module id = 717
// module chunks = 0